import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Box,
    Typography,
    TextField,
    Tooltip,
} from "@mui/material";
import { IconInfoCircle } from "@tabler/icons-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const MarkdownEditorModal = ({
                                         open,
                                         onClose,
                                         title = "System prompt",
                                         value,
                                         onChange,
                                         placeholder = "The prompt text / instructions...",
                                     }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ fontSize: 16, fontWeight: 600 }}>{title}</DialogTitle>
            <DialogContent>
                <Stack direction="row" gap={2} sx={{ height: "60vh", alignItems: "stretch" }}>
                    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                        <Stack direction="row" gap={0.5} alignItems="center" sx={{ mb: 0.5 }}>
                            <Typography variant="caption" fontWeight={600} color="text.secondary">
                                Editor
                            </Typography>
                            <Tooltip
                                title={
                                    <Stack gap={0.3} sx={{ py: 0.5 }}>
                                        <Typography variant="caption"># Heading 1 &nbsp;&nbsp;## Heading 2</Typography>
                                        <Typography variant="caption">**bold** &nbsp;&nbsp;*italic*</Typography>
                                        <Typography variant="caption">`inline code`</Typography>
                                        <Typography variant="caption">- list item &nbsp;&nbsp;1. numbered</Typography>
                                        <Typography variant="caption">[label](url)</Typography>
                                        <Typography variant="caption">&gt; blockquote</Typography>
                                        <Typography variant="caption">--- (horizontal rule)</Typography>
                                    </Stack>
                                }
                                arrow
                                placement="right"
                            >
                                <IconInfoCircle size={13} style={{ cursor: "help", opacity: 0.6 }} />
                            </Tooltip>
                        </Stack>
                        <TextField
                            autoFocus
                            fullWidth
                            multiline
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            InputProps={{
                                sx: {
                                    borderRadius: 0,
                                    fontFamily: "monospace",
                                    fontSize: 13,
                                    height: "100%",
                                    alignItems: "flex-start",
                                },
                            }}
                            sx={{
                                flex: 1,
                                minHeight: 0,
                                "& .MuiInputBase-root": { height: "100%" },
                                "& textarea": { height: "100% !important", overflow: "auto !important" },
                            }}
                        />
                    </Box>

                    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                        <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ mb: 0.5 }}>
                            Preview
                        </Typography>
                        <Box
                            sx={{
                                flex: 1,
                                minHeight: 0,
                                overflow: "auto",
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 0,
                                p: 1.5,
                                fontSize: 13,
                            }}
                        >
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {value || "*Nothing to preview*"}
                            </ReactMarkdown>
                        </Box>
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={onClose}
                    variant="modal"
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MarkdownEditorModal;